import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux'
import Style from 'style-it'
import { DisplayText } from '@shopify/polaris'

// Styles
import './mapper-preview.css'
import '../../../../../public/main.min.css'

const MapperPreviewComponent = (props) => {
  const [moduleClass, setModuleClass] = useState('mapper-preview')
  const activeItem = useSelector(state => state.activeItem)
  const activePinIndex = useSelector(state => state.activePin)
  const pinSettings = activeItem.pins[activePinIndex]
  const getPinSettings = () => {
    if (pinSettings && pinSettings.preset_id && pinSettings.preset_id !== 0) {
      const preset = props.presetData.find(preset => pinSettings.preset_id === preset.id)
      return {
        ...pinSettings,
        ...preset,
        display_data: pinSettings.display_data
      }
    }
    return pinSettings
  }
  const pin = getPinSettings()

  if (!pin) return <div/>

  const transitionClass = useEffect(() => {
    setTimeout(() => {
      setModuleClass(`${moduleClass} ${moduleClass}--active`)
    }, 10)
  }, [props.show])

  return (
    props.show && <div className={moduleClass}>
      <div className="mapper-preview__header">
        <DisplayText size="large">Preview mode</DisplayText>
        <p className="mapper-preview__description">
          This preview uses placeholder data and default font.<br/>
          Your real modal can be slightly different because of languages, text and font.
        </p>
      </div>
      {/*This is mapper placeholder, makeup is taken from mapper API*/}
      <Style>
        {`
          .pin-icon {
            background: ${pin.pin_background}; /* pin_background */
            border-color: ${pin.pin_border}; /* pin_border */
          }
          .pin-icon:hover {
            background: ${pin.pin_hover_background}; /* pin_hover_background */
            border-color: ${pin.pin_hover_border}; /* pin_hover_border */
          }
          .pin-icon:after {
            background: ${pin.pin_dot}; /* pin_dot */
          }
          .pin-icon:hover:after {
            background: ${pin.pin_hover_dot}; /* pin_hover_dot */
          }
          /*Placeholder style*/
          .pin-modal__placeholder {
            background: ${pin.popup_background}; /* popup_background */
            box-shadow: 0 0 5px 5px ${pin.popup_shadow_color};
          }
          .pin-placeholder__arrow {
            border-top-color: ${pin.popup_background};
          }
          .pin-modal__placeholder {
            color: ${pin.popup_title_color}; /* popup_title_color */
            font-style: ${pin.popup_title_font_style}; /* popup_title_font_style */
            font-weight: ${pin.popup_title_font_weight}; /* popup_title_font_weight */
          }
          @media (min-width: 600px) {
            .pin-modal__placeholder {
              font-size: ${pin.popup_title_size}px; /* popup_title_size */
                  }
          }
          /*Modal style*/
          .pin-modal__content {
            background: ${pin.quickview_background}; /* quickview_background */
            box-shadow: 0 0 5px 5px ${pin.quickview_shadow_color};
          }
          .pin-modal__arrow {
            border-top-color: ${pin.quickview_background};
          }
          .pin-modal__header {
            border-color: ${pin.quickview_line_color}; /* quickview_line_color */
          }
          .pin-modal__close:before,
          .pin-modal__close:after {
            background: ${pin.quickview_close_color}; /* quickview_close_color */
          }
          .pin-modal__close:hover:before,
          .pin-modal__close:hover:after {
            background: ${pin.quickview_close_hover_color}; /* quickview_close_hover_color */
          }
          /*Price*/
          .pin-modal__price {
            color: ${pin.product_price_color}; /* product_price_color */
            font-style: ${pin.product_price_font_style}; /* product_price_font_style */
            font-weight: ${pin.product_price_font_weight}; /* product_price_font_weight */
          }
          @media (min-width: 600px) {
            .pin-modal__price {
              font-size: ${pin.product_price_size}px; /* product_price_size */
                  }
          }
          /* Title */
          .pin-modal__title {
            color: ${pin.product_title_color}; /* product_title_color */
            font-style: ${pin.product_title_font_style}; /* product_title_font_style */
            font-weight: ${pin.product_title_font_weight}; /* product_title_font_weight */
          }
          @media (min-width: 600px) {
            .pin-modal__title {
              font-size: ${pin.product_title_size}px; /* product_title_size */
                  }
          }
          /* Description */
          .pin-modal__detail--left {
            color: ${pin.product_description_color}; /* product_description_color */
            font-style: ${pin.product_description_font_style}; /* product_description_font_style */
            font-weight: ${pin.product_description_font_weight}; /* product_description_font_weight */
          }
          @media (min-width: 600px) {
            .pin-modal__detail--left {
              font-size: ${pin.product_description_size}px; /* product_description_size */
                  }
          }
          /*Left button*/
          .pin-modal__footer-button--left {
            color: ${pin.product_btn_one_color}; /* product_btn_one_color */
            font-style: ${pin.product_btn_one_font_style}; /* product_btn_one_font_style */
            font-weight: ${pin.product_btn_one_font_weight}; /* product_btn_one_font_weight */
            background: ${pin.product_btn_one_bg}; /* product_btn_one_bg */
          }
          .pin-modal__footer-button--left:hover {
            color: ${pin.product_btn_one_hover_color}; /* product_btn_one_hover_color */
            background: ${pin.product_btn_one_hover_bg}; /* product_btn_one_hover_bg */
          }
          @media (min-width: 600px) {
            .pin-modal__footer-button--left {
              font-size: ${pin.product_btn_one_size}px; /* product_btn_one_size */
                  }
          }
          /*Right button*/
          .pin-modal__footer-button--right {
            color: ${pin.product_btn_two_color}; /* product_btn_two_color */
            font-style: ${pin.product_btn_two_font_style}; /* product_btn_two_font_style */
            font-weight: ${pin.product_btn_two_font_weight}; /* product_btn_two_font_weight */
            background: ${pin.product_btn_two_bg}; /* product_btn_two_bg */
          }
          .pin-modal__footer-button--right:hover {
            color: ${pin.product_btn_two_hover_color}; /* product_btn_two_hover_color */
            background: ${pin.product_btn_two_hover_bg}; /* product_btn_two_hover_bg */
          }
          @media (min-width: 600px) {
            .pin-modal__footer-button--right {
              font-size: ${pin.product_btn_two_size}px; /* product_btn_two_size */
                  }
          }
          /* Variant Select */
          .pin-modal__select-variants {
            background: ${pin.product_btn_two_bg}; /* product_btn_two_bg */
            border-bottom-color: ${pin.product_btn_two_color}; /* product_btn_two_color */
          }
          .pin-modal__selector-wrapper label,
          .pin-modal__selector-wrapper select {
            color: ${pin.product_btn_two_color}; /* product_btn_two_color */
          }
          .pin-modal__single-option-wrap:after {
            border-color: ${pin.product_btn_two_color}; /* product_btn_two_color */
          }
          .pin-modal__select-variants-close {
            background: ${pin.product_btn_two_bg}; /* product_btn_two_bg */
          }
          .pin-modal__select-variants-close:before,
          .pin-modal__select-variants-close:after {
            border-color: ${pin.product_btn_two_color}; /* product_btn_two_color */
          }
        `}
        <div className="mapper-pin">
          <div className="mapper-pin__inner">
            <div className="pin-icon"/>
            <div className={`pin-modal pin-modal--${pin.display_data}`}>
              {
                !activeItem.disable_tooltip &&
                <div className="pin-modal__placeholder">
                  <span>Lorem ipsum dolor</span>
                  <span className="pin-placeholder__arrow"/>
                </div>
              }
              <div className="pin-modal__content">
                <div className="pin-modal__header">
                  <span className="pin-modal__title">Lorem ipsum dolor</span>
                  <div className="pin-modal__close"/>
                </div>
                <div className="pin-modal__body">
                  <div className="pin-modal__price">
                    <span>$100</span>
                  </div>
                  <div className="pin-modal__details">
                    <div className="pin-modal__detail pin-modal__detail--left">
                      <span>Lorem ipsum dolor</span>
                    </div>
                    <div className="pin-modal__detail pin-modal__detail--right">
                      <img src="" alt="" />
                    </div>
                  </div>
                </div>
                <div className="pin-modal__message"/>
                <div className="pin-modal__footer">
                  <a href="#" className="pin-modal__footer-button pin-modal__footer-button--left">{pin.product_btn_one}</a>
                  <a href="#" className="pin-modal__footer-button pin-modal__footer-button--right">{pin.product_btn_two}</a>
                </div>
                <div className="pin-modal__select-variants">
                  <span id="pin-modal-product-select-1"/>
                </div>
                <span className="pin-modal__arrow"/>
              </div>
            </div>
          </div>
        </div>
      </Style>
    </div>
  )
}

export default MapperPreviewComponent
